import {
    View,
    Text,
    Pressable,
    TextInput,
    ActivityIndicator,
} from 'react-native';
import React from 'react';
import { styles } from '../utils/styles';
import { getColor } from '../utils/theme';
import { goBackTo, height, width } from '../utils/utils';
import { NAVIGATION_BAR_HEIGHT } from '../utils/screen';
import { useTranslation } from 'react-i18next';
import { IModalProps } from './IModalProps';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Keychain from 'react-native-keychain';
import { MpInput } from '../base/MpInput';
import { useState } from 'react';
import User from '../object/User';
import { UserIcon, XMarkIcon } from 'react-native-heroicons/solid';
import { post } from '../utils/http';
import { getErrorMessage } from 'mp-ts-error';
import { HTTPUtils } from 'mp-ts-http';
import { ToastManager } from '../component/toast/ToastManager';
import { Toast } from '../component/toast/Toast';
import { Header } from '../component/Header';
import { CartoucheButton } from '../component/CartoucheButton';
import { GeSpinner } from '../component/GeSpinner';
import { applyResult } from '../utils/applyResult';

export const FirstnameModal = (props: IModalProps) => {
    const { t } = useTranslation();

    const [name, setName] = useState(User._instance.firstname.get() ?? '');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const changeFirstname = () => {
        setLoading(true);
        setError('');
        post('/userperso/update', {
            id: User._instance.getJTOIdentifier(),
            firstname: name,
            lastname: User._instance.lastname.get(),
            description: User._instance.description.get(),
        })
            .then((res) => {
                setLoading(false);
                if (HTTPUtils.isSuccess(res)) {
                    applyResult(HTTPUtils.getResult(res), User._instance, true);
                    User._instance.firstname.set(name);
                    goBackTo(props.navigation, 'Tab', 'FirstnameModal');
                    ToastManager.instance.addToast(
                        new Toast(t('profile_edit_success'), 5000, 'success'),
                    );
                } else {
                    setError(t(HTTPUtils.getError(res)) ?? '');
                }
            })
            .catch((err) => {
                setLoading(false);
                setError(t('went_wrong_no_internet') ?? '');
            });
    };

    return (
        <View style={styles.page}>
            <Header
                modal={true}
                title={t('change_firstname')}
                line={1}
                after={
                    <View
                        style={{
                            height: 10,
                        }}
                    ></View>
                }
                backButton={true}
                navigation={props.navigation}
                rounded={(User._instance.avatar.get() ?? '') !== ''}
                logo={User._instance.avatar.get() ?? ''}
                fallback={
                    <UserIcon
                        color={'white'}
                        size={35}
                    />
                }
            >
                <View
                    style={{
                        marginHorizontal: 20,
                    }}
                >
                    {loading ? (
                        <View
                            style={[
                                styles.boxCenter,
                                {
                                    height: height() * 0.5,
                                },
                            ]}
                        >
                            <GeSpinner color={getColor('primary')} />
                        </View>
                    ) : (
                        <View>
                            <View
                                style={{
                                    marginTop: 15,
                                    marginBottom: 15,
                                }}
                            >
                                <Text
                                    style={[
                                        styles.text,
                                        {
                                            marginBottom: 5,
                                        },
                                    ]}
                                >
                                    {t('firstname')}
                                </Text>
                                <MpInput
                                    style={styles.inputOutilined}
                                    placeholder={t('firstname') ?? ''}
                                    value={name}
                                    defaultValue={name}
                                    onChangeText={(text) => {
                                        setName(text);
                                    }}
                                />
                            </View>

                            {error !== '' && (
                                <Text
                                    style={[
                                        styles.textError,
                                        {
                                            marginTop: 10,
                                        },
                                    ]}
                                >
                                    {error}
                                </Text>
                            )}

                            <View
                                style={{
                                    marginTop: 10,
                                }}
                            >
                                <CartoucheButton
                                    onPress={() => {
                                        changeFirstname();
                                    }}
                                    title={t('validate')}
                                    height={80}
                                />
                            </View>
                        </View>
                    )}
                </View>
            </Header>
        </View>
    );
};
